export enum InvoiceVatPaymentType {
  PaymentBeforeReciept = 1,
  PaymentAfterReciept = 2,
}
